import { Card, Explination, Filter, InfoBox, Pagination, Table, ViewHeader, date, useGet, usePost } from '@enkla-gui'
import { filters, icons } from '@config'

import { UserContext } from '@/App'
import { useContext, useState } from 'react'

export default function Overview() {
	const [filterReady, setFilterReady] = useState(false)
	const { data: tpc } = useGet({ endpoint: 'api/tenantportalconfig' })
	const { data: tenants, setSorting, setPage, sorting, setFilter, fetch: fetchTenants } = useGet({ endpoint: `api/tenant`, enabled: filterReady })
	const { post: inviteAll, loading: invitingAll } = usePost({
		confirm: 'Vill du bjuda in alla hyresgäster som inte har ett konto i hyresgästportalen?',
		success: fetchTenants
	})

	const { billable } = useContext(UserContext)

	const evalHGPstatus = tenant => {
		if (!tpc?.enabled) return
		if (tenant.password !== null) return <span class='badge bg-success'>Aktivt konto</span>
		if (tenant.invite_sent_at !== null) return <span class='badge bg-primary'>Inbjudan skickad {date.short(tenant.invite_sent_at)}</span>
		return <span class='badge bg-warning'>Ej inbjuden</span>
	}

	return (
		<>
			<ViewHeader
				icon={icons.tenant}
				title='Hyresgäst'
				subtitle='Översikt'
				buttons={[
					{ icon: icons.create, title: 'Skapa hyresgäst', href: '#!/tenant/create' },
					{
						icon: icons.send,
						title: 'Bjud in alla till hyresgästportalen',
						hidden: !tpc?.enabled,
						loading: invitingAll,
						callback: () => inviteAll({ endpoint: 'api/tenant/inviteall' })
					}
				]}
			/>
			<div class="row">
				<InfoBox title='Inaktiva Hyresgäster' subtitle={billable?.stat_inactive_tenants} icon='fa-user-times' />
				<InfoBox title='Status hyresgästportalen' subtitle={tpc?.enabled ? 'Aktiv' : 'Inaktiv'} icon='fa-id-badge' link={{ href: '#!/setting/tenantportal' }} />
			</div>
			<Filter filters={filters.tenant} active={{ status: 'ACTIVE' }} useFilter={_filter => {
				setFilter({ ..._filter })
				setFilterReady(true)
			}} />
			<Card>
				<Table
					rows={tenants?.data}
					link={`/#!/tenant/@{id}`}
					loadercount={15}
					functions={{
						hgpstatus: tenant => evalHGPstatus(tenant),
						inactive: inactive => inactive ? <span class="badge bg-warning">Inaktiv <Explination tip='Vad betyder inaktiv hyresgäst?' />
						</span> : ""
					}}
					sorting={sorting}
					useSorting={sort => setSorting({ ...sort })}
					keys={['name', 'identifier', 'phone', 'email', 'created_at>date:short', 'inactive>function:inactive', '_this>function:hgpstatus',]}
					headers={[
						{
							key: 'name',
							value: 'Namn',
							sortable: true
						},
						{
							key: 'identifier',
							value: 'Pers/Org-nummer',
							sortable: true
						},
						{
							key: 'phone',
							value: 'Telefonnummer',
							sortable: true
						},
						{
							key: 'email',
							value: 'E-postadress',
							sortable: true
						},
						{
							key: 'created_at',
							value: 'Skapad',
							sortable: true
						},
						{
							key: 'inactive',
							value: 'Status',
							sortable: false
						},
						{
							value: 'Hyresgästportalen'
						}
					]}
				/>
				<Pagination data={tenants} fetch={setPage} pushToHistory />
			</Card>
		</>
	)
}
